import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { FleetGrid } from '../../../../shared/sso-workspace/fleet-grid'
import { Notice } from '../../../../shared/sso-workspace/fleet-page'
import { serverMessage } from '../../../../shared/sso-workspace/format'
import { TableAgInfinite } from '../../../../shared/table-builder/table-ag-infinite'
import { ColumnFormat } from '../../../../shared/table-builder/table-columns'
import { IconList } from '../../../../shared/icon/icon'
import { getCoverage } from './alert-routing-api'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'

// Organizations on an SSO plan whose own SSO alert list is empty (spec §20.5):
// their SSO alerts fall back to the platform list. Each links to that
// organization's SSO workspace. A failed load shows only its notice: an empty
// list here would say "everyone is covered".
export const SSOCoverageTab = () => {
  const [rows, setRows] = useState(null)
  const [error, failure, setError] = useErrorLine()
  const tableRef = useRef()
  useEffect(() => { getCoverage().then(v => setRows(v || []), err => setError(serverMessage(err, "Coverage couldn't be loaded."), err)) }, [setError])
  const getRows = useMemo(() => async (start, end) => (rows ? { data: rows.slice(start, end), count: rows.length } : { data: [], count: 0 }), [rows])
  return (
    <>
      <p className="sw-hint">Organizations on an SSO plan whose own SSO alert list is empty. They fall back to the platform list.</p>
      {error && <Notice tone="bad" role="alert">{error}<ErrorReference error={failure} /></Notice>}
      {!error && <FleetGrid title="organizations" tableRef={tableRef}>
        <TableAgInfinite key={rows ? rows.length : 'x'} ref={tableRef} queryKey="" onGetRows={getRows}
          emptyState={{ Icon: IconList, title: 'Every SSO organization has a list', message: 'Nothing to chase.' }}>
          <ColumnFormat field="organizationName" header="Organization" sortable={false} minWidth={220} flex={2} render={r => (r.data ? r.value : '')} />
          <ColumnFormat field="organizationID" header="" sortable={false} minWidth={180}
            render={r => (r.data ? <Link to={`/admin/organization/list/edit/${r.value}/sso`} aria-label={`Open the organization ${r.data.organizationName}`}>Open the organization</Link> : '')} />
        </TableAgInfinite>
      </FleetGrid>}
    </>
  )
}
